"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_vis_1 = require("react-vis");
var makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
var core_1 = require("@material-ui/core");
var date_range_1 = require("./util/date-range");
var BaseStatisticsLayout_1 = __importDefault(require("./BaseStatisticsLayout"));
var window_size_1 = require("./util/window-size");
var HeatmapLegend_1 = require("./widgets/HeatMapStatistics/HeatmapLegend");
var useStyles = makeStyles_1.default(function () { return ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        marginTop: 24,
    },
}); });
var processInputStatistics = function (rawStatistics) {
    var zeroed = date_range_1.getZeroedHeatMap();
    var hourMapping = date_range_1.getDayRange();
    var weekdayMapping = date_range_1.getWeekRange();
    rawStatistics.forEach(function (statistics) {
        zeroed
            .filter(function (item) {
            return item.x === hourMapping[statistics.hours] &&
                // In order to move Sunday, represented by index 0, to the final index.
                item.y === weekdayMapping[(statistics.weekday + 6) % 7];
        })
            .forEach(function (filteredItem) {
            /* eslint-disable no-param-reassign */
            filteredItem.color = statistics.clicks;
        });
    });
    return zeroed;
};
var flipChart = function (data) {
    return data.map(function (point) {
        return { x: point.y, y: point.x, color: point.color };
    });
};
function HeatMapStatistics(_a) {
    var weekdayClicks = _a.weekdayClicks;
    var classes = useStyles();
    var theme = core_1.useTheme();
    var isMobileView = core_1.useMediaQuery(theme.breakpoints.down('xs'));
    var _b = __read(react_1.useState(0), 2), width = _b[0], setWidth = _b[1];
    var containerEl = react_1.useRef(null);
    var windowSize = window_size_1.useWindowSize();
    var clicks = processInputStatistics(weekdayClicks);
    // Flip axes in mobile view.
    if (isMobileView) {
        clicks = flipChart(clicks);
    }
    var minClicks = Math.min.apply(Math, __spreadArray([], __read(clicks.map(function (el) { return el.color; }))));
    // Round up to next multiple of 4.
    var maxClicks = Math.ceil(Math.max.apply(Math, __spreadArray([], __read(clicks.map(function (el) { return el.color; })))) / 4) * 4;
    react_1.useEffect(function () {
        if (containerEl != null && containerEl.current != null) {
            setWidth(containerEl.current.getBoundingClientRect().width);
        }
    }, [windowSize]);
    return (react_1.default.createElement(BaseStatisticsLayout_1.default, { title: "When do your users visit?" },
        react_1.default.createElement("div", { ref: containerEl, className: classes.root },
            react_1.default.createElement(react_vis_1.XYPlot, { width: Math.max(width, 275), height: isMobileView ? 500 : Math.max(width * 0.5, 275), margin: { left: 50, top: 32 }, xType: "ordinal", xDomain: isMobileView ? date_range_1.getWeekRange() : date_range_1.getDayRange(), yType: "ordinal", yDomain: isMobileView ? date_range_1.getDayRange().reverse() : date_range_1.getWeekRange().reverse() },
                react_1.default.createElement(react_vis_1.XAxis, { orientation: "top", tickValues: !isMobileView ? ['12am', '6am', '12pm', '6pm'] : undefined, style: {
                        fill: theme.palette.primary.main,
                        fontSize: theme.typography.caption.fontSize,
                    } }),
                react_1.default.createElement(react_vis_1.YAxis, { style: {
                        fill: theme.palette.primary.main,
                        fontSize: theme.typography.caption.fontSize,
                    } }),
                react_1.default.createElement(react_vis_1.HeatmapSeries, { className: "heatmap-statistics", colorRange: [
                        theme.palette.secondary.light,
                        theme.palette.secondary.dark,
                    ], colorDomain: [minClicks, maxClicks], data: clicks, style: {
                        stroke: 'white',
                        strokeWidth: '2px',
                    } })),
            react_1.default.createElement(HeatmapLegend_1.HeatmapLegend, { minClicks: minClicks, maxClicks: maxClicks }))));
}
exports.default = HeatMapStatistics;
